import script from "./NoticeList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeList.vue?vue&type=script&setup=true&lang=js"

import "./NoticeList.vue?vue&type=style&index=0&id=d74f6dbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d74f6dbe"]])

export default __exports__